// An app service answers on the platform's apps domain — `<label>.apps.<cortex host>` —
// and, since the mindshine.com twins (2026-09-08), on the same label under every
// alternate cortex host: `<label>.apps.cortex-demo-2.mindshine.com` when cortex
// itself is opened as cortex-demo-2.mindshine.com. The registry only carries the
// PRIMARY hostUrl (tiva-ai), so every link cortex handed out — Copy link, Open in
// new tab, the Apps embed, the share-page redirect — sent a person who was on the
// mindshine host over to tiva-ai. This keeps the service on the host the page is
// on: same label, `apps.` + the page's own host.
//
// Pure: a URL in, a URL out. Untouched when the page host is local (localhost,
// an IP, anything with a port — no twin exists there), when the service is not
// on an `apps.` domain (a customer's own custom domain, a laptop's
// 127.0.0.1:<hostPort>), or when the page already IS the service's platform host.
export function serviceUrlForHost(serviceUrl, pageHost) {
  const raw = String(serviceUrl || "");
  try {
    const here = String(pageHost == null && typeof window !== "undefined" ? window.location.host : (pageHost || "")).toLowerCase();
    if (!here || /:\d+$/.test(here) || /^(localhost|\[::1\]|\d+\.\d+\.\d+\.\d+)$/.test(here)) return raw;
    const u = new URL(raw);
    if (u.protocol !== "https:") return raw;
    const m = u.host.toLowerCase().match(/^([^.]+)\.apps\.(.+)$/);
    if (!m || m[2] === here) return raw;
    const path = u.pathname === "/" && !/\/(\?|#|$)/.test(raw.slice(u.origin.length) || "") ? "" : u.pathname;
    return `${u.protocol}//${m[1]}.apps.${here}${path}${u.search}${u.hash}`;
  } catch {
    return raw;
  }
}
